// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","icon":"Logo_icon__0ARj8","title":"Logo_title__xuJP2"};